var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnLikeThin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 74,
    viewBox: "0 0 81 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2847 72.4104C30.3115 67.0246 21.9638 60.6858 14.3911 53.5075C9.06719 48.338 5.01411 42.0357 2.54237 35.0836C-1.90559 21.5973 3.28993 6.15801 17.8299 1.58888C25.4715 -0.81032 33.8173 4.59261 40.2566 9.30535C46.6983 4.59835 55.0412 -0.804101 62.6833 1.58888C77.2232 6.15801 82.4561 21.5973 78.0081 35.0836C75.5364 42.0357 71.4833 48.338 66.1594 53.5075C58.5867 60.6858 50.239 67.0246 41.2658 72.4104L40.2939 73L39.2847 72.4104Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnLikeThin);
export default __webpack_public_path__ + "static/media/icn-like-thin.afb145580b090b8d20fd42cd1cdc5ab6.svg";
export { ForwardRef as ReactComponent };